<template>
  <v-card light class="pa-6 pa-md-12" color="white" max-width="calc(100vw - 48px)" :style="cardStyle">
    <v-btn fab small absolute top dark right :elevation="0" class="mt-10" @click="toggleFavorite" :loading="updatingUser"><v-icon color="white">{{isFavorite ? 'mdi-star': 'mdi-star-outline'}}</v-icon></v-btn>
    <v-row class="mb-4">
      <!-- <v-col cols="12" md="5">
        <seo-v-img
          :src="`/media/${listData.heroImage.id}`"
          width="100%"
          :lazy-src="JSON.parse(listData.heroImage.metaData)['image-lazy-src']"
          :aspect-ratio="parseInt(JSON.parse(listData.heroImage.metaData)['image-width']) / parseInt(JSON.parse(listData.heroImage.metaData)['image-height'])"
          />
      </v-col> -->
      <!-- <v-col cols="12" md="7"> -->
      <v-col cols="12">
        <p class="text-subtitle-2 text-md-h4 text-uppercase font-family-heading blue--text">{{listData.room.title}} - {{listData.tag || 'IF!Talk'}}</p>
        <seo-v-img
          v-if="listData.partnerImage"
          class="mb-4"
          :src="optimizedImageURL(listData.partnerImage)"
          width="30%"
          :lazy-src="getMetaData(listData.partnerImage)['image-lazy-src']"
          :aspect-ratio="getAspectRatio(listData.partnerImage)"
          />
        <p class="text-subtitle-1 text-md-h4 font-weight-bold" :style="{color: listData.room.secondaryBackgroundColor}">{{hour}}</p>
        <h1 class="text-h5 text-md-h3 text-uppercase mb-8 blue--text">{{listData.title}}</h1>
        <MarkdownBlock class="text-body-2 text-md-body-1 blue--text" v-if="listData.speakers" :text="listData.speakers" />
      </v-col>
    </v-row>
    <v-expansion-panels flat v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header hide-actions color="white" class="pa-0">
          <template v-slot:default="{ open }">
            <v-row align="center" class="flex-nowrap">
              <v-col cols="auto" class="shrink"><v-btn fab small dark depressed class="v-expansion-panel-header__icon"><v-icon color="white">mdi-chevron-down</v-icon></v-btn></v-col>
              <transition><v-col cols="auto" class="shrink" v-if="!open">Learn More</v-col></transition>
              <v-spacer />
              <v-col cols="auto" class="shrink"></v-col>
            </v-row>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="white" class="pt-8">
          <v-row align="start" no-gutters>
            <template v-if="Talk">
              <v-row align="center" justify="center" no-gutters>
                <v-btn v-if="isCurrentlyLive" depressed rounded dark x-large exact :block="$vuetify.breakpoint.smAndDown" class="px-md-16 ma-4 font-weight-semibold col col-auto" :to="{name: 'Live', params: {slug: listData.room._slug}}" ><v-icon>mdi-play</v-icon><span class="pl-2">Watch</span></v-btn>
                <v-btn v-else-if="isFuture" depressed rounded dark x-large :block="$vuetify.breakpoint.smAndDown" class="px-md-16 ma-4 font-weight-semibold col col-auto" :href="calendarAddLink" target="_blank" rel="nofollow"><CalendarIcon  class="mr-2 calendar-icon" />Add to Google Calendar</v-btn>
                <v-btn v-else-if="Talk.recordingYoutubeURL || Talk.recordingVimeoURL" depressed rounded dark x-large :block="$vuetify.breakpoint.smAndDown" class="px-md-16 ma-4 col col-auto"  :to="{name: 'EventRecording', params: {type: 'Talk', slug: Talk._slug}}" >
                  <v-icon >mdi-play</v-icon><span class="pl-2 font-weight-semibold" >Watch</span>
                </v-btn>
              </v-row>
              <v-col v-if="Talk.aboutDescription" cols="12" :lg="Talk.speakerDescription ? 6: 12">
                <h2 class="text-subtitle-2 mb-2 text-uppercase font-weight-bold blue--text">{{Talk.leftColumnTitle || $root.siteSettings.defaultTalkLeftColumnTitle}}</h2>
                <MarkdownBlock class="text-body-2 text-md-body-1 blue--text" :text="Talk.aboutDescription" />
              </v-col>
              <v-col v-if="Talk.speakerDescription" cols="12" lg="6">
                <h2 class="text-subtitle-2 mb-2 text-uppercase font-weight-bold blue--text">{{Talk.rightColumnTitle || $root.siteSettings.defaultTalkRightColumnTitle}}</h2>
                <MarkdownBlock class="text-body-2 text-md-body-1 blue--text" :text="Talk.speakerDescription" />
              </v-col>
            </template>
            <template v-else>
              <v-col cols="12">
                <v-skeleton-loader type="heading" class="mb-4"/>
                <v-skeleton-loader type="sentences" />
              </v-col>
            </template>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import { MarkdownBlock } from '@monogrid/vue-lib'
import CalendarIcon from '@/assets/img/google-calendar-icon.svg'
import GetTalk from '@/graphql/GetTalk.gql'
import UpdateUser from '@/graphql/mutations/UpdateUser.gql'
import { optimizedImageURL, getMetaData, getAspectRatio } from '@/services/OptimizedImage'

export default {
  name: 'TalkBigCard',
  components: {
    MarkdownBlock,
    CalendarIcon
  },
  data () {
    return {
      panel: null,
      updatingUser: false
    }
  },
  props: {
    listData: {
      type: Object,
      required: true
    }
  },
  watch: {
    panel (value) {
      console.log(value)
    }
  },
  methods: {
    optimizedImageURL,
    getMetaData,
    getAspectRatio,
    async toggleFavorite () {
      this.updatingUser = true
      let favoriteTalks
      if (!this.isFavorite) {
        favoriteTalks = this.$root.databaseUser.favoriteTalks
          ? this.$root.databaseUser.favoriteTalks.map(t => `_reference/Talk/${t.id}`).concat([`_reference/Talk/${this.listData.id}`])
          : [`_reference/Talk/${this.listData.id}`]
      } else {
        favoriteTalks = this.$root.databaseUser.favoriteTalks.concat() // clone it
        const index = favoriteTalks.findIndex(t => t.id === this.listData.id) // find index
        favoriteTalks.splice(index, 1) // Remove
        favoriteTalks = favoriteTalks.map(t => `_reference/Talk/${t.id}`) // replace objects with references
      }
      try {
        await this.$apollo.mutate({
          mutation: UpdateUser,
          variables: {
            id: this.$root.databaseUser.id,
            input: { favoriteTalks }
          }
        })
      } catch (e) {
        console.error(e)
      }
      this.updatingUser = false
    }
  },
  computed: {
    isFavorite () {
      return this.$root.databaseUser.favoriteTalks ? this.$root.databaseUser.favoriteTalks.findIndex(t => t.id === this.listData.id) !== -1 : false
    },
    isCurrentlyLive () {
      const now = this.$root.getNow().getTime()
      const start = new Date(this.listData.startingAt).getTime()
      const end = new Date(this.listData.endingAt).getTime()
      return now >= start && now < end
    },
    isFuture () {
      const now = this.$root.getNow().getTime()
      const start = new Date(this.listData.startingAt).getTime()
      return now < start
    },
    cardStyle () {
      if (this.Talk) {
        return {
          boxShadow: `6px 6px 0 3px ${this.Talk.room.primaryBackgroundColor} !important`
        }
      }
      return {}
    },
    calendarAddLink () {
      const sd = new Date(this.listData.startingAt).toISOString().replace(/(-|:|\.000Z)/g, '')
      const ed = new Date(this.listData.endingAt).toISOString().replace(/(-|:|\.000Z)/g, '')
      return `https://calendar.google.com/calendar/r/eventedit?text=${encodeURIComponent(this.listData.title)}&dates=${sd}/${ed}&ctz=Etc/GMT&details=${encodeURIComponent(this.listData.aboutDescription)}`
    },
    hour () {
      const start = new Date(this.listData.startingAt).toLocaleTimeString(this.$language.current, { hour: 'numeric', minute: 'numeric' })
      const end = new Date(this.listData.endingAt).toLocaleTimeString(this.$language.current, { hour: 'numeric', minute: 'numeric' })
      const date = new Date(this.listData.endingAt).toLocaleDateString(this.$language.current, { month: 'long', day: 'numeric' })

      return `${start} - ${end}, ${date}`
    }
  },
  apollo: {
    Talk: {
      query: GetTalk,
      variables () {
        return {
          status: 'PUBLISHED',
          id: this.listData.id
        }
      },
      result () {
        // this.$root.$emit('scroll-to-saved-position')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-icon {
  width: 30px;
  height: 30px;
}

// .v-card {
//   box-shadow: 6px 6px 0 3px map-deep-get($colors, 'strong-blue', 'base') !important;
// }
</style>
